import InstallerService from "../../../../services/web/installer-service.js";

const toOption = ({value, label}) => ({value, label});

export const loadStreets = (search, callback) => {
    InstallerService.streets(search)
        .then((data) => callback((data ?? []).map(toOption)))
        .catch(() => callback([]));
};

export const loadNeighborhoods = (search, callback) => {
    InstallerService.neighborhoods(search)
        .then((data) => callback((data ?? []).map(toOption)))
        .catch(() => callback([]));
};

// Keeps latitude/longitude on the option: picking a city fills the coordinates,
// as in the legacy select2 handler.
export const loadCities = (search, callback) => {
    InstallerService.cities(search)
        .then((data) => callback((data ?? []).map(({value, label, text, latitude, longitude}) => ({
            value: value ?? text,
            label: label ?? text,
            latitude,
            longitude,
        }))))
        .catch(() => callback([]));
};

export const errorMessage = (error, fallback) => {
    if (error?.response && error.response.status !== 500) {
        return error.response.data?.message ?? fallback;
    }

    return fallback;
};
